import { TForm, TInvalidFields } from '../models'

export const getInitFormState = <T>(init?: T): TForm<T> => ({
  formData: init === undefined ? ({} as T) : init,
  modifiedFields: [],
  invalidFields: {} as TInvalidFields<T>,
  isValid: true,
})
